import { ProductHeaderData } from '@/types/product-pages';
import { Navigation } from './navigation';
import { ActionButtons } from './action-buttons';
import { ActionMenuItem } from '@/types/menu';
import { Logo } from './logo';

interface ProductHeaderProps {
  data: ProductHeaderData;
  actions: ActionMenuItem[];
}

export default function ProductHeader({ data, actions }: ProductHeaderProps) {
  return (
    <div className="h-18 bg-[#00589A]">
      <div className="flex container mx-auto h-full items-center justify-between py-4 gap-2 max-w-7xl px-6 xl:px-0">
        <div className="flex items-center gap-8">
          <Logo href="#" variant={data.nome} />
          <Navigation items={data.items} className="flex items-center gap-6" />
        </div>
        <ActionButtons items={actions} />
      </div>
    </div>
  );
}
